import React from "react";
import { ICustomer } from "../../../../models/Customer";
import CustomerSummaryTable from "./CustomerSummaryTable";
import CustomerNotes from "./CustomerNotes";
import styles from "./CustomerInfo.module.scss";


const CustomerInfo: React.FC<ICustomer> = (props) => {
  return (
    <>
      {/* Table = Minimal output formatting.  Use blueprint for production-quality format. */}
      <div>
        <br></br>
        
        <div className={styles.infoContainer}>
          {/* Customer Summary Table */}
          <div className={styles.summarySection}>
            <CustomerSummaryTable
              id={props.id}
              name={props.name}
              dpmsType={props.dpmsType}
              isActive={props.isActive}
              agentId={props.agentId}
              timeZoneName={props.timeZoneName}
              lastIngressSession={props.lastIngressSession}
              lastEgressSession={props.lastEgressSession}
              lastEgressEntityFailure={props.lastEgressEntityFailure}
            />
          </div>

          {/* Notes Section - Right Side */}
          <CustomerNotes notes={props.notes} />
        </div>
      </div>
    </>
  );
}

export default CustomerInfo;


